function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "26",
  height: "18",
  viewBox: "0 0 26 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.88.85L.78 8.04a.45.45 0 00-.26.49c.04.21.23.36.45.36h2.69v6.47c0 .99.83 1.8 1.86 1.8h7.46c1.03 0 1.86-.81 1.86-1.8V9.47c0-1.06.9-2.01 1.99-2.03 1.14-.02 2.07.87 2.07 1.96v5.96c0 .99.83 1.8 1.86 1.8 1.03 0 1.86-.81 1.86-1.8V5.12l2.49-.42a.45.45 0 00.38-.44v-.01c0-.19-.12-.35-.3-.42L16.88.85zm-6.39 12.16H8.02c-.34 0-.62-.27-.62-.6v-2.39c0-.33.28-.6.62-.6h2.47c.34 0 .62.27.62.6v2.39c0 .34-.28.6-.62.6z",
  fill: "currentColor",
  fillRule: "evenodd"
})));